module.exports = __webpack_public_path__ + "img/TDC-L2-6-Pagina2 B.cf4cb35f.png";